

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _md = _interopRequireDefault(require("./../../../md5"));

var _index = _interopRequireDefault(require("./utils/index"));

var _pageEvent = _interopRequireDefault(require("./pageEvent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function(sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

// eslint-disable-next-line no-loop-func
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function(key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function(key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Track = /*#__PURE__*/function() {
  function Track(options) {
    (0, _classCallCheck2["default"])(this, Track);

    // super(props);
    this._init(options);
  }
  /**
   * @description: 初始化 
   * @param {null} 
   * @return {null} 
   */


  (0, _createClass2["default"])(Track, [{
    key: "_init",
    value: function _init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var defaultOptions = {
        pageLoad: true
      };
      this.logOrder = 1; //记录埋点顺序

      this.params = {}; //存放公共参数

      this.options = _objectSpread(_objectSpread({}, defaultOptions), options); //配置项合并

      this._getCommonParams(); //获取公共参数


      new _pageEvent["default"](this); //页面事件绑定
    }
    /**
     * @description: 兼容原有kooEventLog事件
     * @param { string } 事件类型 ['click', 'pageload', 'ajaxSuccess', ]
     * @param { object | string } 自定义data
     */

  }, {
    key: "kooEventLog",
    value: function kooEventLog(type, data) {
      var privateData = {};

      switch (type) {
        case "click":
          privateData = this._getClickParams(data);
          break;

        case "pageLoad":
          privateData = this._getPageViewParams(data);
          break;

        case "ajaxSuccess":
          privateData = this._getAjaxSuccessParams(data);
          break;

        default:
          console.error("Unknown weblog type: ".concat(type, "."));
          break;
      }

      var url = this._getImgUrl(type);

      this._sendStrack(url, privateData);
    }
  }, {
    key: "_sendStrack",
    value: function _sendStrack(url, obj) {
      var privateData = this._setLogOrder(obj);

      var finalObj = _index["default"].extend({}, this.params, privateData);

      var queryStr = this._joinQueryParams(finalObj);

      _index["default"].send(url, queryStr); // 打印日志顺序加1，打一条日志就加1


      this.logOrder++;
    }
    /**
     * @description: 更新日志顺序
     * @param {type} 
     * @return {type} 
     */

  }, {
    key: "_setLogOrder",
    value: function _setLogOrder(obj) {
      var res = obj || {};
      res.data = res.data || {};
      res.data.logorder = this.logOrder;
      return res;
    }
  }, {
    key: "_joinQueryParams",
    value: function _joinQueryParams(params) {
      // 获取域名
      // var domain = window.document.domain; // 获取发送请求的时间，在发送请求前一刻记录时间而不是在函数的最顶部，最顶部和发送前一刻的时间可能不同

      var time = 1 * new Date(); // 获取sign签名,之所不写在公用参数方法中，是因为发送日志的时间戳这发送前才能获取
      // todo 老逻辑getAppidKey_log返回空对象
      // const appid = this.getAppidKey_log(domain).appid || "";
      // const appkey = this.getAppidKey_log(domain).appkey || "";

      var appid = '';
      var appkey = '';
      var sign = (0, _md["default"])(appid + "&" + time + appkey); // 获取appid

      params.appid = appid;
      params.clits = time;
      var data = this.getLineParams(params.data);
      var content = encodeURIComponent(JSON.stringify(_objectSpread(_objectSpread({}, params), {}, {
        data: data
      })));

      var logType = this.options.logType || _index["default"].getLogType();

      var queryParams = _index["default"].setQueryString({
        logtype: logType,
        content: content,
        appid: appid,
        sign: sign,
        clits: time
      });

      return queryParams;
    }
    /**
     * @description: 参数驼峰改为下划线加小写模式 eventId=> event_id
     * @param {object} 
     * @return {object} 
     */

  }, {
    key: "getLineParams",
    value: function getLineParams(obj) {
      var _this = this;

      var res = {};

      _index["default"].each(obj, function(v, k) {
        if (_index["default"].isObject(v)) {
          res[_index["default"].toLine(k)] = _this.getLineParams(v);
        } else {
          res[_index["default"].toLine(k)] = v;
        }
      });

      return res;
    }
    /**
     * @description: 根据埋点类型生成imgName
     * @param {string}
     * @return {string}
     */

  }, {
    key: "_getImgUrl",
    value: function _getImgUrl(type) {
      var env = this.options.env;
      var isCType = ["systemLog", "errorLog", "performancelog", "ajaxTraceLog"].indexOf(type) !== -1;
      var fileName = "a";

      if (type === "click") {
        fileName = "b";
      } else if (isCType) {
        fileName = "c";
      }

      var url = _index["default"].getHost(env);

      return "".concat(url, "/").concat(fileName, ".gif");
    }
  }, {
    key: "click",
    value: function click(obj) {
      var url = this._getImgUrl("click");

      var privateData = this._getClickParams(obj);

      this._sendStrack(url, privateData);
    }
  }, {
    key: "pageView",
    value: function pageView(obj) {
      var url = this._getImgUrl();

      var privateData = this._getPageViewParams(obj);

      this._sendStrack(url, privateData);
    }
  }, {
    key: "log",
    value: function log(obj) {
      var url = this._getImgUrl("systemLog");

      var privateData = this._getLogParams(obj);

      this._sendStrack(url, privateData);
    }
    /**
     * @description: 公共数据
     * @param { null }
     * @return { object }
     */

  }, {
    key: "_getCommonParams",
    value: function _getCommonParams() {
      var _t = this;

      var commonParams = this.options.params;
      var params = {}; // 全局配置项赋值

      if (_index["default"].isObject(commonParams)) {
        params = _objectSpread({}, commonParams);
      }

      params.data = {};
      params.kuid = _index["default"].getKuid(); // 获取UN网盟字段信息

      params.koolearn_netalliance_cookie = _index["default"].getCookie("koolearn_netalliance_cookie") || "";
      params.koolearn_netalliance_criteo = _index["default"].getCookie("koolearn_netalliance_criteo") || ""; // 获取userid

      params.ssoid = _index["default"].getCookie("sso.ssoId") || ""; // 获取sid，这里因为kooupapp中没有ssoid，所以额外上传了一下sid

      params.sid = _index["default"].getCookie("sid") || ""; // 获取pageid即title

      params.pageid = window.title || window.document.title || ""; // 获取ssosessid 原 sessid

      params.ssosessid = _index["default"].getCookie("ssoSessionID") || ""; // sessid 会话级session 新增 todo 预埋cookie

      params.session = _index["default"].getCookie("log.session") || ""; // ab测试参数 新增

      params.abtest = _index["default"].getCookie("log.abtest") || ""; // 获取产品线标识

      params.kooline = _index["default"].getCookie("koo.line") || ""; // 获取ua

      params.ua = window.navigator.userAgent || ""; // 获取ip

      params.ip = window.returnCitySN || {
        cid: "",
        cip: "",
        cname: ""
      }; // 当前页面的链接
      // params.data.currenthref = window.location.href;
      // 获取来源页地址

      params.data.refHref = window.document.referrer || ""; // 当前日志在当前页属于的条数即顺序

      params.data.logorder = _t.logOrder; // 添加clientid字段

      params.clientid = _index["default"].clientUserAgent();
      _t.params = params;
    }
    /**
     * @description: 点击事件上报
     * @param { object|string }
     * @return { object }
     */

  }, {
    key: "_getClickParams",
    value: function _getClickParams() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // var _t = this; // 页面可视区域高度


      var pageView_height = _index["default"].getPageHeight();

      var privateData = {
        data: {}
      }; // todo polyfill old data

      if (obj && obj.params) {
        if (_index["default"].isString(obj.params)) {
          var params = _index["default"].parseStr(obj.params);

          _index["default"].each(params, function(v, k) {
            privateData.data[k] = v;
          });
        } else if (_index["default"].isObject(obj.params)) {
          _index["default"].each(obj.params, function(v, k) {
            privateData.data[k] = v;
          });
        }
      } else {
        _index["default"].each(obj, function(v, k) {
          // 排除dom节点
          if (k !== 'elem') {
            privateData.data[k] = v;
          }
        });
      }

      var elem = obj && obj.elem ? obj.elem : window.document.body; // 获取发生交互行为的元素名称

      privateData.data.elemname = elem.tagName.toLowerCase(); // 获取点击元素时距离页面X坐标

      privateData.data.posx = _index["default"].offsetLT(elem).left; // 获取点击元素时距离页面Y坐标

      privateData.data.posy = _index["default"].offsetLT(elem).top; // 获取ajaxhref

      privateData.data.ajaxhref = ""; // 获取logid，点击行为日志每次的logid都是每个页面中唯一的一个logid，存在cookie中prelogid参数中

      privateData.logid = _index["default"].getCookie("prelogid") || ""; // 点击行为设置prevlogid字段一直为空

      privateData.prelogid = window.koo_webLog_prelogid || "";
      privateData.data.currenthref = window.location.href; // 页面当前停留区域的高度,即页面当前是在第几屏（只有点击元素交互行为和页面渲染完成时有）

      privateData.data.currentpagescreen = Math.ceil((window.document.body.scrollTop ? window.document.body.scrollTop : window.document.documentElement.scrollTop) / pageView_height) + 1; // 页面最大高

      privateData.data.p_hight = Math.max(window.document.body.scrollHeight || 0, window.document.documentElement.scrollHeight || 0, window.document.body.offsetHeight || 0, window.document.documentElement.offsetHeight || 0, window.document.body.clientHeight || 0, window.document.documentElement.clientHeight || 0);
      return privateData;
    }
    /**
     * @description: pv
     * @param {object|string}
     * @return {object}
     */

  }, {
    key: "_getPageViewParams",
    value: function _getPageViewParams(obj) {
      var privateData = {
        data: {}
      };

      // var _t = this;

      var pageView_height = _index["default"].getPageHeight();

      var pageView_width = _index["default"].getPageWidth(); // 浏览器分辨率


      privateData.data.resolution = (window.screen.width || 0) + "/" + (window.screen.height || 0); // 页面可视区域的宽和高

      privateData.data.pageviewsize = pageView_width + "/" + pageView_height; // 页面当前停留区域的高度,即页面当前是在第几屏（只有点击元素交互行为和页面渲染完成时有）

      privateData.data.currentpagescreen = Math.ceil((window.document.body.scrollTop ? window.document.body.scrollTop : window.document.documentElement.scrollTop) / pageView_height) + 1; // 获取logid,页面渲染完成的logid也是页面中唯一的logid,在页面加载时已经存在cookie prelogid参数中

      privateData.logid = _index["default"].getCookie("prelogid") || ""; // 获取上一次发送日志请求的页面logid，只有页面渲染完成和ajax请求完成时发送日志才需要prevlogid

      privateData.prelogid = window.koo_webLog_prelogid || ""; // _.getCookie('prelogid') || '';
      // 解析页面渲染完成时页面传递过来的参数，存在参数解析，否则不解析

      if (_index["default"].isString(obj)) {
        var values = _index["default"].parseStr(obj);

        _index["default"].each(values, function(v, k) {
          privateData.data[k] = v;
        });
      } else if (_index["default"].isObject(obj)) {
        _index["default"].each(obj, function(v, k) {
          privateData.data[k] = v;
        });
      } // 设置eventid
      // privateData.data.eventid = _t.eventid || "";
      // 记录页面是否加载完毕的，是否存在资源加载失败，如果存在则记录失败的个数
      // todo lodStatus没有发生过变化 该段感觉可以删除
      // if (_t.loadStatus == 0) {
      //   // 统计页面资源加载状态
      //   privateData.data.loadstatus = "success";
      // } else {
      //   // 统计页面资源加载状态
      //   privateData.data.loadstatus = "fail";
      //   // 统计页面资源加载失败的个数
      //   privateData.data.failresourcenum = _t.loadStatus;
      // }


      privateData.data.currenthref = window.location.href;
      privateData.data.eventid = this.eventid || '';
      privateData.data.loadstatus = "success";
      return privateData;
    }
    /**
     * @description: 请求成功上报
     * @param {type}
     * @return {type}
     */

  }, {
    key: "_getAjaxSuccessParams",
    value: function _getAjaxSuccessParams(obj) {
      var privateData = {}; // 获取ajax请求完成时业务方在header头部response中的logid值

      privateData.logid = obj.newLogid || ""; // 获取上一次发送日志请求的logid，只有页面渲染完成和ajax请求完成时发送日志才需要prevlogid

      privateData.prelogid = _index["default"].getCookie("prelogid") || ""; // 获取ajax请求的连接

      privateData.data.ajaxhref = obj.ajaxHref || ""; // ajax请求成功返回的数据,如果需要传递数据就传一个ajaxMsg字段，不需要不传，是否需要根据obj.ajaxMsg是否存在

      if (obj.ajaxMsg) {
        privateData.data.ajaxmsg = obj.ajaxMsg || "";
      } // 获取特殊字段ajaxSuccessParamsConfig


      if (window.ajaxSuccessParamsConfig) {
        // 解析window.addSpecialLogParamsConfig参数
        var values = _index["default"].parseStr(window.ajaxSuccessParamsConfig);

        _index["default"].each(values, function(v, k) {
          privateData.data[k] = v;
        });

        window.ajaxSuccessParamsConfig = "";
      }

      privateData.data.currenthref = window.location.href;
      return privateData;
    }
    /**
     * @description: log上报
     * @param {object}
     * @return {object}
     */

  }, {
    key: "_getLogParams",
    value: function _getLogParams(obj) {
      var privateData = {
        data: {
          eventid: ''
        }
      };

      _index["default"].each(obj, function(v, k) {
        privateData.data[k] = v;
      });

      privateData.data.currenthref = window.location.href;
      return privateData;
    }
  }]);
  return Track;
}();

; // export default (window => Track)(ENV)

var _default = Track;
exports["default"] = _default;